module.exports = __webpack_public_path__ + "media/images/reviews/bbb-f577c9c05e143dbaf108b65a3d97d3e1.svg";